import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';

// Protected route component that checks authentication before rendering admin panel
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Check authentication status
  const checkAuth = () => {
    const token = sessionStorage.getItem('adminToken');
    const authenticated = sessionStorage.getItem('adminAuthenticated');
    
    // Verify token exists and is valid
    if (token && authenticated === 'true') {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setIsChecking(false);
  };

  // Check authentication on mount
  useEffect(() => {
    checkAuth();

    // Listen for storage changes (for logout from other tabs/windows)
    const handleStorageChange = (e) => {
      if (e.key === 'adminToken' || e.key === 'adminAuthenticated') {
        checkAuth();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Handle successful login
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  // Show loading state while checking authentication
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // If authenticated, render the protected component (AdminPanel)
  if (isAuthenticated) {
    return children;
  }

  // If not authenticated, show login form
  return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
};

export default ProtectedRoute;

